import { captureException } from '@sentry/nextjs';

import { isProduction } from './environment';
import { toErrorWithMessage } from './errorMessage';

export function handleError(error: unknown) {
	if (isProduction()) {
		// Capture error with Sentry
		captureException(error);
	} else {
		// When not in production throw the error again to make it explicit that something went wrong
		throw toErrorWithMessage(error);
	}
}
